import { render, staticRenderFns } from "./servicePermissions.vue?vue&type=template&id=7e073ad7&scoped=true&"
import script from "./servicePermissions.vue?vue&type=script&lang=js&"
export * from "./servicePermissions.vue?vue&type=script&lang=js&"
import style0 from "./servicePermissions.vue?vue&type=style&index=0&id=7e073ad7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e073ad7",
  null
  
)

export default component.exports